// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VY44","top":"styles_top__283pr"};